"use client"

import { Button, Text } from "@/elements"
import React, { FC } from "react"
import { ControlledModal } from "../Dialog"
import { ProBadge } from "./SubscriptionCheckoutModal/components/ProBadge"

interface Props {
  isOpen: boolean
  onOpenChange: (isOpen: boolean) => void
  onClickGoPro: () => void
}

export const UnlockJobFiltersModal: FC<Props> = ({ isOpen, onOpenChange, onClickGoPro }) => {
  return (
    <ControlledModal
      open={isOpen}
      onClose={() => onOpenChange(false)}
      fullScreenOnMobile={false}
      closeIconButtonVariant="transparent"
      contentClassName="bg-pro-gradient-100  px-0 pb-0 pt-[60px] sm:px-8 sm:pb-8"
      onOpenChange={onOpenChange}
      body={
        <div className="flex flex-col items-center justify-center">
          <div>
            <ProBadge variant="transparent" />
          </div>
          <Text variant="h5" className="mt-6 text-center">
            Unlock job filters and find relevant jobs with NOVA Pro
          </Text>
          <Button onClick={onClickGoPro} className="mt-8 w-full sm:w-auto" variant="pro-primary" size="large">
            Unlock Pro
          </Button>
        </div>
      }
    />
  )
}
